import { MpFlexContainer } from './FlexContainer'
export default MpFlexContainer

export { MpFlexContainer, MpFlexContainerProps } from './FlexContainer'
